import React from 'react';
import PropTypes from 'prop-types';

class MonthlyToAnnual extends React.Component {
    render() {
        let constants = this.props.app.config.constants,
            planTotal = this.props.promo.price + (this.props.planAddOns * this.props.promo.addOnPrice),
            planName = (this.props.user.detail.pubLevel === constants.PUB_LEVEL_6) ? 'Pro' : 'Plus',
            mainCopy = '';

        // if (this.props.planTweets !== undefined) {
        //     planTotal += (this.props.planTweets * this.props.promo.tweetPrice);
        // }

        mainCopy = (this.props.planAddOns) ? `One year of ${planName} with your current add ons for $${planTotal}` : `One year of ${planName} for just $${this.props.promo.price}`

        return (
            <div className="promo-content">
                {this.props.image ? (
                    this.props.image
                ) : null}
                <div className="main-copy">
                    {mainCopy}
                </div>
                <div className="sub-copy">
                    Lock in our best available price for your plan. Limited time offer.
                </div>
                <div className="promo-action-button" role="button" aria-label="Claim the deal"  onClick={this.props.onRedeemPromoClick}>
                    {this.props.isWorking ? (
                        <span>
                            <i className="fa fa-spinner fa-spin"></i>
                        </span>
                    ) : 'Get our best price'}
                </div>
                <div className="last-chance">
                    {`Move to the annual plan and get 12 months for just $${planTotal} today`}
                </div>
                <div className="coming-soon">
                    <h3>Hands-Free Social Media Publishing</h3>
                    <div className="feature-list">
                        {this.props.features.map((feature, i) => {
                            return (
                                <div key={`feature-${i}`} className="feature-detail">
                                    <div className="feature-image">
                                        <img src={feature.image}/>
                                    </div>
                                    <div className="feature-name">
                                        {feature.label}
                                    </div>
                                    <div className="feature-desc">
                                        {feature.description}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

MonthlyToAnnual.displayName = "MonthlyToAnnual";

MonthlyToAnnual.propTypes = {
    image: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.object
    ]),
    promo: PropTypes.object,
    onRedeemPromoClick: PropTypes.func,
    features: PropTypes.array,
    planAddOns: PropTypes.number,
    isWorking: PropTypes.bool
};

MonthlyToAnnual.defaultProps = {
    image: null,
    promo: null,
    onRedeemPromoClick: () => {},
    features: [],
    planAddOns: 0,
    isWorking: false
};

export default MonthlyToAnnual;
